import { Box, Tooltip, Typography } from '@mui/material';
import { useRecordContext } from 'react-admin';
import React from 'react';

export function DescriptionField({ children }) {
  const record = useRecordContext() || {};
  const { description } = record;
  if (!description) {
    return null;
  }
  return (
    <Tooltip
      sx={{ direction: 'rtl' }}
      title={(
        <Box sx={{ direction: 'rtl' }}>
          { description.split('|').map((line, index) => (
            <Typography key={line} component="p" variant="body2" color="textSecondary">{line}</Typography>
          ))}
        </Box>
      )}
    >
      {children || <Typography variant="body2" color="textSecondary">{description}</Typography>}
    </Tooltip>
  );
}

DescriptionField.defaultProps = {
  label: 'Desc',
};
